var e=0,r=["column","column-reverse"];export{e as DEFAULT_DIVIDER_MARGIN,r as VERTICAL_DIRECTIONS};
//# sourceMappingURL=FGStack.shared.js.map
